import React, { ReactNode } from 'react';
import theme from '../utils/themeColors';

interface EmptyStateProps {
  title: string;
  description?: string;
  icon?: ReactNode;
  action?: {
    label: string;
    onClick: () => void;
  };
}

/**
 * Empty state component for displaying when content is not available
 * Used for loading, error, and empty states
 */
const EmptyState: React.FC<EmptyStateProps> = ({ 
  title, 
  description, 
  icon,
  action 
}) => {
  return (
    <div className="flex flex-col items-center justify-center text-center p-8 h-full min-h-[300px]">
      {icon && <div className="mb-4">{icon}</div>}
      
      <h2 className={`text-xl font-bold ${theme.text.primary} mb-2`}>
        {title}
      </h2>
      
      {description && (
        <p className={`${theme.text.secondary} mb-6 max-w-md`}>
          {description}
        </p>
      )}
      
      {action && (
        <button
          onClick={action.onClick}
          className={`inline-flex items-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium ${theme.button.primary}`}
        >
          {action.label}
        </button>
      )}
    </div>
  );
};

export default EmptyState;
